<template>
  <div class="container">
    <div class="cont">
      <img
        src="../assets/img/bgImg.png"
        style="width: 100%"
        class="img"
        alt=""
      />
      <!-- <div class="title">富裕钱包</div> -->
    </div>
    <div class="inputGrpup">
      <div class="bgWhite">
        <div class="phone_sty">
          <img src="../assets/img/hx.png" alt="">
          <span>您的朋友({{phone}})邀请你注册</span>
          <img src="../assets/img/hx.png" alt="">
        </div>
        <van-cell-group>
          <!-- <van-field
            class="lister"
            v-model="form.nickName"
            type="txt"
            placeholder="请输入真实姓名"
            maxlength='11'
          > -->
          <!-- </van-field> -->
          <van-field
            class="lister phone"
            type="tel"
            v-model="form.phone"
            @keydown.native="keyDown($event)"
            maxlength="11"
            @input="
              (value) => {
                form.phone = value.replace(/[^\d]+/g, '');
              }
            "
            placeholder="请输入手机号"
          />
          <van-field
            class="lister psw"
            :type="seePsw ? 'password' : 'text'"
            @input="
              (value) => {
                form.password = value.replace(/[^\w_]/g, '');
              }
            "
            v-model="form.password"
            placeholder="请设置8~16位数字+字母组合密码"
          >
            <template #button>
              <div @click="handSeePsw">
                <img
                  src="../assets/img/bieyes.png"
                  alt=""
                  v-show="seePsw == true"
                />
                <img
                  src="../assets/img/eyes.png"
                  alt=""
                  style="width: 18px"
                  class="see"
                  v-show="seePsw == false"
                />
              </div>
            </template>
          </van-field>
          <van-field
            class="lister code2"
            v-model="form.verifyCode"
            maxlength="6"
            @input="
              (value) => {
                form.verifyCode = value.replace(/[^\d]+/g, '');
              }
            "
            placeholder="请输入验证码"
          >
            <template #button>
              <div class="code">
                <div class="codeGroup">
                  <div>|</div>
                  <div class="subCondeGrpup">
                    <span
                      @click="start"
                      class="codeTxt"
                      v-show="timeStatus == '0001'"
                      >获取验证码</span
                    >
                    <div v-show="timeStatus == '0000'" class="sub">
                      <van-count-down
                        ref="countDown"
                        millisecond
                        :time="time"
                        :auto-start="false"
                        format="ss"
                        @finish="finish"
                      />&nbsp;&nbsp;&nbsp; 秒后重试
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </van-field>
          <van-field
              class="lister phone2"
              v-model="form.commendCode"
              label="推荐码"
              label-width="50px"
              readonly
              style="padding-left:10px;background:none"
            />
        </van-cell-group>
        <div>
          <van-button
            color="linear-gradient(0deg, #FF2125, #FFC219)"
            block
            @click="submit"
            class="btn"
            :loading="submitDisabled=='0001'"
            style="margin-top:20px"
          >
            立即注册
          </van-button>
          <div class="info">
            注册即同意
            <span class="agreement" @click="handServeAgreementsUrl"
              >《用户服务协议》和</span
            >
            <span class="agreement" @click="handPrivateAgreementUrl">
              《隐私政策》
            </span>
          </div>
          <van-button
            block
            class="btn"
            @click="handDlownload"
            style="color: #ffba00"
          >
            立即下载
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { isPoneAvailable } from "../assets/js/common";
import { Field } from "vant";
import { Button } from "vant";
import { CellGroup } from "vant";
import { Toast, CountDown, Form } from "vant";

import { shareUrl, baseUrl } from "../assets/js/api";

// import { mapState,mapMutations } from "vuex"

Vue.use(Field);
Vue.use(Button);
Vue.use(CellGroup);
Vue.use(Toast);
Vue.use(CountDown);
Vue.use(Form);
export default {
  data() {
    return {
      submitDisabled:"0000",
      isDisabled: "0000",
      time: 60000,
      timeStatus: "0001", //0001的话显示倒计时  0000显示倒计时
      value: "",
      seePsw: true,
      url: "https://spapps-api.hkrt.cn/app-api", //公共地址
      // 需要提交的数据
      form: {
        phone: "", //手机号码
        password: "", //密码
        verifyCode: "", //验证码
        commendCode: "", //推荐码
        appTag: 1, //类型 appTag  0 佳付通  1 富裕钱包
        referPhone:'',//邀请人手机号
      },
      phone:'',//邀请人手机号
    };
  },
  created() {
    document.title = "注册";
    let commendCode = this.$route.query.commendCode || sessionStorage.getItem("commendCode");
    if(!!commendCode){
      this.form.commendCode = commendCode;
      sessionStorage.setItem("commendCode", commendCode);
    }
    let phone = this.$route.query.phone || sessionStorage.getItem("phone");
    if(!!phone){
      this.phone = phone;
      sessionStorage.setItem('phone',phone);
    }
    // 判断是否回显上次输入的值
    if(this.$route.query.isBack && this.$route.query.isBack=='0000'){
      this.getInfos()
    }
  },
  methods: {
    // 获取信息
    getInfos(){
      let { phone,password } = this.$store.state.shareInfos
      this.form.password = password
      this.form.phone = phone
    },

    // 存储到vuex
    vuexStorage(){
      this.$store.commit("setShareInfo",this.form)
    },


    keyDown(e) {
      if (e.keyCode == 32) {
        e.returnValue = false;
      }
    },
    handSeePsw() {
      this.seePsw = !this.seePsw;
    },

    handPrivateAgreementUrl() {
      this.vuexStorage()
      this.$router.push({
        name: "privateAgreements",
      });
    },
    handServeAgreementsUrl() {
      this.vuexStorage()
      this.$router.push({
        name: "serveAgreements",
      });
    },
    // handDlownload() {
    //   this.$router.push({
    //     name: "download",
    //     query:{
    //       appTag:this.form.appTag,
    //       commendCode:this.form.commendCode,
    //     }
    //   });
    // },
    handDlownload() {
      this.$router.push({
        name: "downloadforpublic",
      });
    },
    start() {
      if (this.form.phone == "") {
        Toast("手机号不能为空");
        return false;
      }

      if (isPoneAvailable(this.form.phone) == false) {
        Toast("手机号输入有误");
        return false;
      }
      // 0001代表不让点击

      if (this.isDisabled == "0001") {
        console.log("不让点击");
        return false;
      }
      this.isDisabled = "0001";
      let obj = {
        phone: this.form.phone,
        commendCode: this.form.commendCode,
        appTag:1
      };
      baseUrl("/message/v1/webSend", obj)
        .then((res) => {
          console.log(res);
          this.isDisabled = "0000";
          if (res.data.code == "0000") {
            this.timeStatus = "0000";
            this.$refs.countDown.start();
          } else {
            Toast(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.isDisabled = "0000";
        });
    },
    pause() {
      this.$refs.countDown.pause();
    },
    reset() {
      this.$refs.countDown.reset();
    },
    finish() {
      this.timeStatus = "0001";
      // this.time = 60000;
      this.reset();
    },
    //   注册按钮点击
    submit() {
      if (this.form.phone == "") {
        Toast("手机号不能为空");
        return false;
      }
      if (isPoneAvailable(this.form.phone)) {
        Toast("手机号格式有误");
        return false;
      }
      if (this.form.password == "") {
        Toast("密码不能为空");
        return false;
      }
      if (this.form.password.length < 8 || this.form.password.length > 16) {
        Toast("密码长度为8-16位");
        return false;
      }

      let regp = /^(?=.*[a-zA-Z]+)(?=.*[0-9]+)[a-zA-Z0-9]+$/;

      if (!regp.test(this.form.password)) {
        Toast("密码得包含数字和字母");
        return false;
      }

      if (this.form.verifyCode == "") {
        Toast("验证码不能为空");
        return false;
      }
      this.submitDisabled = '0001'
      this.form.referPhone = this.phone;
      baseUrl("/userBase/v1/webRegister", this.form)
        .then((res) => {
          console.log(res);
          this.submitDisabled = '0000'
          if (res.data.code == "0000") {
            this.handDlownload();
          }
          Toast(res.data.msg);
        })
        .catch((err) => {
          this.submitDisabled = '0000'
          console.log(err);
        });
    },
    // 获取验证码
    // getCode() {
    //   this.timeStatus = "0000";
    //   let obj = {
    //     phone: this.form.phone,
    //     commendCode: this.form.commendCode,
    //   };
    //   shareUrl("/api/message/v1/webSend",obj)
    //     .then((res) => {
    //       console.log(res);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
  },
};
</script>

<style scoped>
.container {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  margin: 0 auto;
  max-width: 500px;
  height: 100vh;
  background: rgb(255,43,73);
  /* background-image: linear-gradient(#fff1e0, #ff9940, #ffbe5c, #ffedd2); */
}
.cont {
  margin: 0 auto;
}
.img {
  width: 100%;
}
.inputGrpup {
  padding: 0 15px;
  box-sizing: border-box;
  position: absolute;
  top: 35%;
  width: 100%;
}
.bgWhite {
  background: white;
  padding: 20px 20px;
  border-radius: 15px;
}
/deep/ .van-cell {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding:8px 16px
}
.title{
  font-size: 28px;
  font-weight: bold;
  padding-left: 20px;
  padding-top: 20px;
}

/deep/ .van-count-down {
  line-height: inherit;
  color: #ffba00;
}
.see {
  transform: translateY(3px);
}
.lister {
  margin-bottom: 10px;
  background: url("../assets/img/name.png") no-repeat 7px center;
  background-size: 15px 15px;
}
.phone {
  background: url("../assets/img/phone.png") no-repeat 7px center;
  background-size: 15px 20px;
}
.psw {
  background: url("../assets/img/psw.png") no-repeat 7px center;
  background-size: 18px 20px;
}
.code2 {
  background: url("../assets/img/code.png") no-repeat 7px center;
  background-size: 18px 20px;
}
.code {
  color: #ffba00;
  display: flex;
}
/deep/ .btn {
  border-radius: 44px;
}
/deep/ .van-field__value {
  padding-left: 15px;
}
.phone2 /deep/ .van-field__value {
  padding-left: 0;
}
.info {
  font-size: 14px;
  text-align: center;
  margin: 15px 0;
}
.agreement {
  color: #ffba00;
  font-size: 14px;
}
.codeGroup {
  width: 80px;
  display: flex;
  justify-content: space-between;
}
.subCondeGrpup {
  display: flex;
  justify-content: center;
  width: 100%;
}
.sub {
  display: flex;
}
.codeTxt {
  cursor: pointer;
}
.phone_sty{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #333;
  padding-bottom: 15px;
}
.phone_sty span{
  padding: 0 10px;
}
.phone_sty img{
  width: 33px;
  height: 1px;
}
.lister /deep/ .van-field__label{
  color: #323233;
}
</style>